export default "__VITE_ASSET__BAMchISp__"